import script from "./ransomware-incident.vue?vue&type=script&setup=true&lang=ts"
export * from "./ransomware-incident.vue?vue&type=script&setup=true&lang=ts"

import "./ransomware-incident.vue?vue&type=style&index=0&id=672efa73&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672efa73"]])

export default __exports__